
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Edit, Eye, Play } from "lucide-react";
import { ActionButton } from "../ui/ActionButton";
import Card from "../common/Card"; // Your actual Card component
// import { ActionButton } from "./ActionButton";
import { EnergyLabel } from "./EnergyLabel";

export const ProjectCard = ({ name, description, imageUrl, id, energyLabel, navigateTo = "edit" }) => {
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  const handleProjectClick = () => {
    localStorage.setItem("projectID", id);
    const route = navigateTo === "execute" ? `/project-processing/${id}` : `/project-edit/${id}`;
    navigate(route);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoading(false);
  };

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const buttonConfig = {
    edit: { text: "Edit Project", variant: "primary" },
    execute: { text: "Execute", variant: "success" }
  };

  const config = buttonConfig[navigateTo] || buttonConfig.edit;

  return (
    <div className="group bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer">
      {/* Image Section */}
      <div className="relative h-48 overflow-hidden" onClick={handleProjectClick}>
        {imageLoading && (
          <div className="absolute inset-0 bg-gradient-to-br from-slate-100 to-slate-200 animate-pulse" />
        )}

        {imageError ? (
          <div className="w-full h-48 bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center">
            <div className="text-center">
              <Eye className="w-8 h-8 text-slate-400 mx-auto mb-2" />
              <span className="text-slate-500 text-sm">Image unavailable</span>
            </div>
          </div>
        ) : (
          <img
            src={imageUrl}
            alt={name}
            className={`w-full h-48 object-cover transition-all duration-300 group-hover:scale-110 ${
              imageLoading ? "opacity-0" : "opacity-100"
            }`}
            onError={handleImageError}
            onLoad={handleImageLoad}
          />
        )}

        <EnergyLabel label={energyLabel} />
        
        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300" />
      </div>

      {/* Content Section */}
      <div className="p-6 space-y-4">
        <h3 className="text-lg font-bold text-slate-800 group-hover:text-blue-600 transition-colors duration-200 line-clamp-1">
          {name}
        </h3>
        <p className="text-slate-600 text-sm leading-relaxed line-clamp-2">
          {description || "No description available"}
        </p>
        
        {/* Action Section */}
        <div className="flex items-center justify-between pt-4 border-t border-slate-100">
          <span className="text-xs text-slate-500 font-medium">ID: {id}</span>
          <ActionButton 
            onClick={(e) => {
              e.stopPropagation();
              handleProjectClick();
            }}
            variant={config.variant}
            className="text-xs"
          >
            {navigateTo === "execute" ? (
              <Play className="w-4 h-4 mr-1" />
            ) : (
              <Edit className="w-4 h-4 mr-1" />
            )}
            {config.text}
          </ActionButton>
        </div>
      </div>

      {/* Hover Glow Effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-600/0 via-indigo-600/0 to-blue-600/0 group-hover:from-blue-600/5 group-hover:via-indigo-600/5 group-hover:to-blue-600/5 transition-all duration-300 pointer-events-none rounded-xl"></div>
    </div>
  );
};